export default __webpack_public_path__ + "static/media/dilmah.a25ab373.svg";